import shiwtchtyles from "../../../styles/UI/simpleSwitch.module.css";

export type Placement = "BEFORE" | "ABOVE" | "TAILING";

const Switch = ({
  id,
  checked,
  disabled,
  label,
  labelPlacement,
  onChange,
  width,
}: {
  id: string;
  checked: boolean;
  disabled?: boolean;
  labelPlacement?: Placement;
  label?: string;
  width?: number; //Should be added, when label is passed in.
  onChange: (checked: boolean) => void;
}) => {

  return (
    <label
      htmlFor={id}
      className={`${shiwtchtyles.switchWrapper} ${labelPlacement === "ABOVE" && "flex-col"}`}
      style={{ width: width && width.toString() + "px" }}
    >
      <p>{(labelPlacement === "BEFORE" || labelPlacement === "ABOVE") && label}</p>
      <div className={shiwtchtyles.switch}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
        />
        <span className={`${shiwtchtyles.slider} ${shiwtchtyles.round} ${disabled && shiwtchtyles.disabled}`}></span>
        {checked ? (
          <span className={`${shiwtchtyles.sliderCircleIconLine} ${disabled && shiwtchtyles.disabled}`}></span>
        ) : (
          <span className={`${shiwtchtyles.sliderCircleIconCircle} ${disabled && shiwtchtyles.disabled}`}></span>
        )}
      </div>
      {labelPlacement === "TAILING" && label}
    </label>
  );
};

export default Switch;